import { EDITCATEGORY_SUCCESS, EDITCATEGORY_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const editCategoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDITCATEGORY_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case EDITCATEGORY_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default editCategoryReducer;
